exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmbedBlock-43b84a6a{position:relative;display:block;width:100%;max-height:700px;text-align:center}.EmbedBlock-43b84a6a iframe{position:absolute;width:100%;height:100%;top:0;left:0;right:0;bottom:0}\n", ""]);

// Exports
exports.locals = {
	"EmbedBlock": "EmbedBlock-43b84a6a"
};